'use strict';

var isExternalUrl = require('../../../../../../../../_virtual/isExternalUrl.cjs');

var hasRequiredIsExternalUrl;

function requireIsExternalUrl () {
	if (hasRequiredIsExternalUrl) return isExternalUrl.__exports;
	hasRequiredIsExternalUrl = 1;

	/**
	 * Determines if a URL is external by checking if it starts with http://, https://, or www.
	 *
	 * Returns false for relative URLs and undefined/null values.
	 */ const isExternalUrl$1 = (url)=>{
	    if (!url) return false;
	    try {
	        if (url.startsWith("/")) return false;
	        // Check for www. or http(s)://
	        return /^(https?:\/\/)|(www\.)/i.test(url);
	    } catch  {
	        return false;
	    }
	};

	isExternalUrl.__exports.isExternalUrl = isExternalUrl$1;
	
	return isExternalUrl.__exports;
}

exports.__require = requireIsExternalUrl;
//# sourceMappingURL=isExternalUrl.cjs.map
